import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
  EntityState,
} from "@reduxjs/toolkit";
import { newsAPI as API, NewsItem as Item } from "../../apis/news";
import { RootState } from "../store";

export const loadNews = createAsyncThunk(
  "news/load",
  (page: number = 1) => API.fetchPage(page),
  {
    condition: (page, { getState }: any) => {
      const { news } = getState() as RootState;
      if (news.status !== "idle") return false;
    },
  }
);

export const loadNewsItem = createAsyncThunk(
  "news/loadItem",
  (id: number) => API.fetchItem(id),
  {
    condition: (id, { getState }: any) => {
      const { news } = getState() as RootState;
      if (news.entities[id] !== undefined) return false;
    },
  }
);

const itemsAdapter = createEntityAdapter<Item>();
interface News extends EntityState<Item> {
  status: "idle" | "loading" | "succeeded" | "failed";
}
const initialState: News = {
  ...itemsAdapter.getInitialState(),
  status: "idle"
};

const isPendingAction = ({ type }: any) =>
  type.startsWith("news/") && type.endsWith("/pending");
const isRejectedAction = ({ type }: any) =>
  type.startsWith("news/") && type.endsWith("/rejected");

const slice = createSlice({
  name: "news",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadNews.fulfilled, (state, { payload }) => {
        state.status = "succeeded";
        itemsAdapter.setAll(state, payload.data);
      })
      .addCase(loadNewsItem.fulfilled, (state, { payload }) => {
        state.status = "succeeded";
        itemsAdapter.addOne(state, payload.data);
      })
      .addMatcher(isRejectedAction, (state) => {
        state.status = "failed";
      })
      .addMatcher(isPendingAction, (state) => {
        state.status = "loading";
      });
  },
});

export default slice.reducer;
